import React, { FC } from 'react';
import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import { times } from 'lodash';

import { LoaderComponents } from 'components';

import TableHeader from './TableHeader';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  rows: number;
}

const useStyles = makeStyles(theme => ({
  tableBodyRow: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.common.white,
    height: 65,
    '&:nth-child(even)': {
      backgroundColor: theme.palette.grey[50],
    },
  },
}));

const MemberTableLoader: FC<IProps> = ({ rows }) => {
  const classes = useStyles();
  const { Block, Content } = LoaderComponents;

  return (
    <Table>
      <TableHeader hasActions />
      <TableBody>
        {times(rows, (rowIndex: number) => (
          <TableRow className={classes.tableBodyRow} key={rowIndex}>
            <TableCell />
            <TableCell colSpan={2}>
              <Content height={15} maxWidth={160} />
            </TableCell>
            <TableCell>
              <Block height={10} width={25} />
            </TableCell>
            <TableCell>
              <Content height={15} maxWidth={100} />
            </TableCell>
            <TableCell>
              <Content height={15} maxWidth={100} />
            </TableCell>
            <TableCell>
              <Content height={15} maxWidth={50} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MemberTableLoader;
